var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOurTeamLeftStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560.64 677.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.75 41.4 64.72 50.53 74.32 50.53 66.55 56.18 69.52 65.31 61.75 59.67 53.98 65.31 56.95 56.18 49.18 50.53 58.78 50.53 61.75 41.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "143.18 184.08 146.15 193.21 155.75 193.21 147.99 198.85 150.95 207.99 143.18 202.34 135.42 207.99 138.38 198.85 130.62 193.21 140.22 193.21 143.18 184.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.18 502.51 52.15 511.64 61.75 511.64 53.98 517.28 56.95 526.42 49.18 520.77 41.41 526.42 44.38 517.28 36.61 511.64 46.21 511.64 49.18 502.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "219.49 45.4 220.83 49.51 225.14 49.51 221.65 52.05 222.99 56.15 219.49 53.62 216 56.15 217.33 52.05 213.84 49.51 218.16 49.51 219.49 45.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.18 231.61 50.52 235.71 54.83 235.71 51.34 238.25 52.67 242.36 49.18 239.82 45.69 242.36 47.02 238.25 43.53 235.71 47.85 235.71 49.18 231.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "143.18 313.75 144.52 317.85 148.84 317.85 145.34 320.39 146.68 324.5 143.18 321.96 139.69 324.5 141.03 320.39 137.53 317.85 141.85 317.85 143.18 313.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "79.97 371.25 81.31 375.35 85.62 375.35 82.13 377.89 83.47 382 79.97 379.46 76.48 382 77.81 377.89 74.32 375.35 78.64 375.35 79.97 371.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "296.98 89.4 298.32 93.51 302.64 93.51 299.14 96.05 300.48 100.15 296.98 97.62 293.49 100.15 294.83 96.05 291.33 93.51 295.65 93.51 296.98 89.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "504.68 59.93 506.01 64.04 510.33 64.04 506.84 66.58 508.17 70.69 504.68 68.15 501.19 70.69 502.52 66.58 499.03 64.04 503.35 64.04 504.68 59.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "554.98 0 556.32 4.11 560.64 4.11 557.14 6.65 558.48 10.75 554.98 8.21 551.49 10.75 552.83 6.65 549.33 4.11 553.65 4.11 554.98 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "334.83 15.01 336.16 19.12 340.48 19.12 336.98 21.65 338.32 25.76 334.83 23.22 331.33 25.76 332.67 21.65 329.17 19.12 333.49 19.12 334.83 15.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.65 .57 6.99 4.67 11.31 4.67 7.81 7.21 9.15 11.32 5.65 8.78 2.16 11.32 3.49 7.21 0 4.67 4.32 4.67 5.65 .57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "30.96 667.21 32.29 671.31 36.61 671.31 33.12 673.85 34.45 677.96 30.96 675.42 27.47 677.96 28.8 673.85 25.31 671.31 29.63 671.31 30.96 667.21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurTeamLeftStars);
export default __webpack_public_path__ + "static/media/our_team_left_stars.7e654acdb612ac69c6e0414fdd5b684f.svg";
export { ForwardRef as ReactComponent };